module.exports = __webpack_public_path__ + "img/u2.5a1f2031.png";